import { useContext } from 'react'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { TreeView } from '@mui/x-tree-view'
import { CvsTreeItem } from '../styled-components'
import { FolderNode } from '../types'
import { FolderFilterContext } from './context'
import { FolderTreeItemLabel } from './folder-filter-tree-item-label'

interface FolderTreeItemProps {
  folder: FolderNode
}

export const FolderTreeItem = ({ folder }: FolderTreeItemProps) => {
  const { selectedFolder, reducers, treeState } = useContext(FolderFilterContext)

  if (!folder)
    return (
      <>
        [
        <div key="stub" />]
      </>
    )

  const expanded = folder.open ? [folder.path] : []

  return (
    <TreeView
      defaultCollapseIcon={<ExpandMoreIcon />}
      defaultExpandIcon={<ChevronRightIcon />}
      expanded={expanded}
      onNodeToggle={() => reducers.setIsOpen([treeState], folder.path, !folder.open)}
      sx={{ borderLeft: 'solid 1px rgba(0, 0, 0, 0.87)' }}
    >
      <CvsTreeItem
        nodeId={folder.path}
        label={
          <FolderTreeItemLabel
            folder={{ path: folder.path, label: folder.label }}
            selectedFolder={selectedFolder}
          />
        }
      >
        {folder.children
          ? folder.children.map((folder, index) => <FolderTreeItem folder={folder} key={index} />)
          : [<div key="stub" />]}
      </CvsTreeItem>
    </TreeView>
  )
}
